const origin = window.location.origin;

let /** @type {string} */ backendUrl,
  /** @type {string} */ authUrl,
  /** @type {string} */ iamUrl,
  /** @type {string} */ rmsUrl,
  /** @type {string} */ simUrl,
  /** @type {string} */ tdmUrl,
  /** @type {string} */ tgdmUrl,
  /** @type {string} */ qaosUrl;

if (!origin.startsWith("http://localhost")) {
  backendUrl = window.location.origin.replace("://", "://api.");
  authUrl = backendUrl;
  iamUrl = backendUrl;
  rmsUrl = backendUrl;
  simUrl = backendUrl;
  tdmUrl = backendUrl;
  tgdmUrl = backendUrl;
  qaosUrl = backendUrl;
} else {
  if (sessionStorage.getItem("isNotLocalBackend") === "true") {
    backendUrl = "https://api.dev.convoy.tessell.cloud";
    authUrl = backendUrl;
    iamUrl = backendUrl;
    rmsUrl = backendUrl;
    simUrl = backendUrl;
    tdmUrl = backendUrl;
    tgdmUrl = backendUrl;
    qaosUrl = backendUrl;
  } else {
    backendUrl = "http://localhost:8001";
    authUrl = "http://localhost:8002";
    iamUrl = "http://localhost:8003";
    rmsUrl = "http://localhost:8007";
    simUrl = "http://localhost:8006";
    tdmUrl = "http://localhost:8005";
    tgdmUrl = "http://localhost:8005";
    qaosUrl = "http://localhost:8004";
  }
}
export {
  backendUrl,
  authUrl,
  iamUrl,
  rmsUrl,
  simUrl,
  tdmUrl,
  tgdmUrl,
  qaosUrl,
};

export const devopsUrl = `${backendUrl}/devops`;

export const githubUrl = "https://github.com/TessellDevelopment";

export const grafanaUrl = "https://grafana.proxy.convoy.tessell.cloud/";

export const jiraMainLabelDashbord =
  "https://tessell.atlassian.net/jira/dashboards/10106";
